export default __webpack_public_path__ + "static/media/testimony_teacher_one.d0014255.png";